module.exports = "<span>地図情報提供：ESRI</span>\n"